import React from "react"
import { Link } from "gatsby"
import styles from "./ArticleThumbnail.module.scss"
import LazyLoad from "react-lazyload"
import { slugify, getTimestamp } from "../../lib/helpers"
import { StaticImage } from "gatsby-plugin-image"

const ArticleThumbnail = ({ article, isLeadText, isLoading }) => {
  const { title, leadtext, published, id, mainImage, images } = article
  const { caption, normal } = mainImage || images[0] || {}
  return (
    <Link
      to={`/artikkel/${slugify(title)}`}
      className={styles.articleThumbnail}
    >
      <div className={mainImage ? styles.imageWrapper : undefined}>
        {!!mainImage ? (
          <LazyLoad height="66.667%" offset={100}>
            <img src={normal} alt={caption} />
          </LazyLoad>
        ) : (
          <StaticImage
            src="../../images/news_thumbnail.webp"
            alt="Kronprinsparets Fond logo"
          />
        )}
      </div>

      <div>
        <div>{getTimestamp(published)}</div>
        <p>{title}</p>
        {isLeadText && <p>{leadtext}</p>}
      </div>
    </Link>
  )
}

export default ArticleThumbnail
